import * as vp from 'vopay';
import { FunctionComponent, useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { DialogueHandler, FlexibleInfoDialogueHandler } from './types';
import FlexibleInfoContext from './FlexibleInfoContext';
import styles from './FlexibleInfoDialogue.module.scss';

const { Modal, Button } = vp;

type FlexibleInfoDialogueProps = {
  handleDialogue: DialogueHandler<FlexibleInfoDialogueHandler>;
};

type FC = FunctionComponent<FlexibleInfoDialogueProps>;

const FlexibleInfoDialogue: FC = ({ handleDialogue }: FlexibleInfoDialogueProps) => {
  const { showInfo } = useContext(FlexibleInfoContext);
  const { t } = useTranslation('translations', { keyPrefix: 'FlexiblePaymentOptions' });

  return useMemo(
    () => (
      <>
        <div>
          {/* Agree PAD Agreement */}
          <Modal isVisible={showInfo} enableBgClick={false}>
            <div className={styles.InfoModal}>
              <h2 className={styles.InfoModalHeader}>{t('popupTitle')}</h2>
              <div className={styles.InfoModalContent}>
                <div className={styles.InfoItem}>
                  <h3 className={styles.InfoItemHeader}>{t('multiplePaymentMethods')}</h3>
                  <p className={styles.InfoItemHDescription}>{t('multiplePaymentMethodsDescription')}</p>
                </div>
                <div className={styles.InfoItem}>
                  <h3 className={styles.InfoItemHeader}>{t('partialPayments')}</h3>
                  <p className={styles.InfoItemHDescription}>{t('partialPaymentsDescription')}</p>
                </div>
                <div className={styles.InfoItem}>
                  <h3 className={styles.InfoItemHeader}>{t('installmentPlans')}</h3>
                  <p className={styles.InfoItemHDescription}>{t('installmentPlansDescription')}</p>
                </div>
              </div>

              <div className={styles.CrossContainer}>
                <Button
                  id='pre-authorized-debit-close"'
                  color="secondary"
                  label=""
                  iconLocation="center"
                  icon="cross"
                  iconSize="md"
                  iconWidth="17px"
                  background="none"
                  noShadow
                  onClick={() => {
                    handleDialogue({ type: 'info', state: 'fail' });
                  }}
                />
              </div>
            </div>
          </Modal>
        </div>
      </>
    ),
    [showInfo],
  );
};

export default FlexibleInfoDialogue;
